import { useEffect, useState } from 'react';
import { getPublicPage } from '../../lib/api';
import type { CustomPage } from '../../lib/types';
import { BlockRenderer } from '../components/BlockRenderer';
import { NotFoundPage } from './NotFoundPage';

export function CustomPageView({ page }: { page: CustomPage }) {
  return <><header className="page-hero"><p className="eyebrow">Casa Borinquen</p><h1>{page.title}</h1>{page.summary && <p className="page-hero__lead">{page.summary}</p>}</header><section className="prose"><BlockRenderer blocks={page.blocks} /></section></>;
}

export function CustomPageRoute({ slug }: { slug: string }) {
  const [page, setPage] = useState<CustomPage | null | undefined>(undefined);
  useEffect(() => { getPublicPage(slug).then(setPage).catch(() => setPage(null)); }, [slug]);
  if (page === undefined) {
    const provisionalTitle = slug.split('-').filter(Boolean).map((word) => `${word.charAt(0).toUpperCase()}${word.slice(1)}`).join(' ');
    return <section className="not-found" aria-label="Loading page"><h1>{provisionalTitle}</h1><p>Loading…</p></section>;
  }
  return page ? <CustomPageView page={page} /> : <NotFoundPage />;
}
